export default "__VITE_ASSET__CNuo9O_M__"